/**
 * Weltspiegel Template
 * Main entry point for all JavaScript and CSS
 */

// Import CSS
import "../css/template.css";

// Import modules
import "./_navigation.js";
import "./_truncate.js";
import "./_showbox.js";
import "./_youtube.js";
import "./_cookie-consent.js";
import "./_current-events.js";
import "./_gallery.js";
import "./_image-popout.js";
import "./_back-link.js";
import "./_day-filter.js";
import "./_fsk-filter.js";

// Export for potential external use
export default {};
